import {ReactElement, ReactNode} from "react";

export interface ErrorMessageProps {
    children: ReactNode
}

export function ErrorMessage(props: ErrorMessageProps): ReactElement {
    return <p className="text-accent">
        {props.children}
    </p>
}